import * as React    from 'react';
import { Link }      from 'react-router-dom';
import { Countdown } from '../../../new-components';

import { useCommon } from '../../../providers/common';

const TopPromotions = function(props) {
  const {
          activeFrom,
          activeTo,
          announce,
          date,
          headImage,
          label,
          showCounter,
          urlKey,
        } = props;

  const common = useCommon();

  return (
    <Link
      className={'top_promotion_container'}
      to={`${common.getUrlByTemplate('akcii')}/${urlKey}`}
    >
      <picture>
        <source
          srcSet={`${headImage}.webp?default=horizontal&t=${BUILD_TIME}`}
          type={'image/webp'}
        />
        <img
          alt={label}
          src={`${headImage}.png?default=horizontal&t=${BUILD_TIME}`}
        />
      </picture>
      <div className={'top_promotion_time_container'}>
        <p className={'top_promotion_time_date'}>{date}</p>
        {showCounter && (
          <Countdown
            from={activeFrom}
            to={activeTo}
          />
        )}
      </div>
      <h3 className={'top_promotion_title'}>{label}</h3>
      <p className={'top_promotion_description'}>{announce}</p>
      <div className={'top_promotion_tags'}></div>
    </Link>
  );
};

export default TopPromotions;